import React, { FC, useId } from 'react'
import { ClbTooltip } from '@celebration/react'
import { NxTooltipPosition } from './types'

type NxTooltipProps = {
  position: NxTooltipPosition
  label: string
  ariaLabel?: string
  children: React.ReactElement | string | number | undefined
}

const NxTooltip: FC<NxTooltipProps> = ({
  position,
  label,
  ariaLabel,
  children,
}): React.ReactElement => {
  const id = useId()

  return (
    <ClbTooltip
      id={id}
      position={position}
      description={label}
      showArrow={true}
      colorMode={'dark'}
      aria-label={ariaLabel}
      data-testid='tooltip'
    >
      {children}
    </ClbTooltip>
  )
}

export default NxTooltip
